var FROM_TYPE_OPTIONS = [{
  value: 1,
  label: '自营'
}, {
  value: 2,
  label: '福司令'
}];
var SHOW_TYPE_OPTIONS = [{
  value: 1,
  label: '展示'
}, {
  value: 0,
  label: '不展示'
}];
var TRANSPORT_OPTIONS = [{
  value: '1',
  label: '快递发货'
}, {
  value: '2',
  label: '专人配送'
}, {
  value: '3',
  label: '用户自提'
}];
export { FROM_TYPE_OPTIONS, SHOW_TYPE_OPTIONS, TRANSPORT_OPTIONS };